/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'underscore',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/QueryDataItemSetAPI'
], (_, APIFactory, QueryDataItemSetAPI) => {
	class QueryDataItemSet {

		constructor() {
			this.dataItems = [];
			this.dataItemSets = [];
			this.calculations = [];
			this.summariesEnabled = true;	//By default, summaries are shown.
			this.detailItemSet = false;
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [QueryDataItemSetAPI]);
			}
			return this.api;
		}

		addDataItem(dataItem) {
			this.dataItems.push(dataItem);
		}

		addDataItemList(dataItems) {
			this.dataItems.splice(this.dataItems.length, 0, ...dataItems);
		}

		setDataItemList(queryDataItems) {
			this.dataItems = queryDataItems;
		}

		getDataItemList() {
			return this.dataItems.slice();
		}

		addCalculation(operator, operands) {
			if (this.isMeasureItemSet()) {
				this.calculations.push({
					operator,
					operands
				});
			}
		}

		getCalculationList(columnId) {
			return columnId ? this.calculations.filter(calc => calc.operands.indexOf(columnId) > -1) : this.calculations;
		}

		getAllDataItemsList() {
			return _.flatten([
				this.getDataItemList(),
				this.getDataItemSetList().map(
					dataItemSet => dataItemSet.getAllDataItemsList()
				)
			]);
		}

		createDataItemSet(dataItems) {
			const dataItemSet = new QueryDataItemSet();
			dataItemSet.addDataItemList(dataItems);
			this.dataItemSets.push(dataItemSet);
			return dataItemSet.getAPI();
		}

		getDataItemSetList() {
			return this.dataItemSets.slice();
		}

		isNestedItemSet() {
			return this.dataItemSets.length > 0;
		}

		isMeasureItemSet() {
			return this.dataItems && this.dataItems[0] && this.dataItems[0].getType() === 'fact';
		}

		getSummaryItemPrefix() {
			return 'summary:';
		}

		isSummaryItemId(id) {
			return id.indexOf(this.getSummaryItemPrefix()) === 0;
		}

		setIsDetailItemSet(detailItemSet) {
			this.detailItemSet = detailItemSet;
		}

		isDetailItemSet() {
			return this.detailItemSet;
		}
	}

	return QueryDataItemSet;

});